export default {
	'Phone must be verified': 'Phone must be verified'
}
